import { logo2w } from '../assets';
import { navLinks } from '../constants';
import { HashLink } from 'react-router-hash-link';


const Footer = () => {
  return (
    <>
      <footer className="mt-0 flex-none">
        <div className="sm:px-8">
          <div className="mx-auto w-full max-w-7xl lg:px-8">
            <div className="border-t border-tertiary pb-16 pt-10">
              <div className="relative px-8 lg:px-12">
                <div className="mx-auto max-w-2xl lg:max-w-5xl">
                  <div className="flex justify-between items-center gap-10">
                    <div className="flex flex-col sm:flex-row sm:flex-wrap sm:pl-10 justify-center gap-x-6 gap-y-1 text-sm font-medium">
                      {navLinks.map(({ title, id }, idx) => (
                        <HashLink
                          className="transition text-txt-secondary"
                          to={`#${id}`}
                          key={idx}
                        >
                          {title}
                        </HashLink>
                      ))}
                    </div>
                    <div>
                      <img
                        loading='lazy' fetchPriority="high"
                        className="w-full max-w-[200px] opacity-60 img-logo"
                        src={logo2w}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
